export enum EQuestionTypeEnum {
  SINGLE_CHOICE = 0, // 单选
  MULTIPLE_CHOICE, // 多选
  JUDGE, // 判断
  SUBJECTIVE, // 主观题
}
